<template>
    <ValidationProvider v-slot="{ errors }" v-bind="$attrs">
        <slot></slot>
        <span class="error">{{ errors[0] }}</span>
    </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
export default {
    name: "ValidatedField",
    components: {
        ValidationProvider
    },

}
</script>
    
<style lang="scss" scoped>
    .error {
        color: red;
    }
</style>
